import React from 'react';
import './Videos.css';

function Videos() {
  const videos = [
    {
      title: 'Git i GitHub des de zero - Curs complet',
      author: 'MoureDev by Brais Moure',
      lang: 'Castella',
      duration: '5h',
      embedId: '3GymExBkKjE',
      desc: 'Curs complet de Git i GitHub en espanyol. Cobreix des de la instal·lacio fins a conceptes avancats.',
      level: 'Principiant',
    },
    {
      title: 'Aprende Git ahora! - Curso completo GRATIS',
      author: 'HolaMundo',
      lang: 'Castella',
      duration: '1h',
      embedId: 'VdGzPZ31ts8',
      desc: 'Tutorial rapid i directe per entendre els conceptes basics de Git en una hora.',
      level: 'Principiant',
    },
    {
      title: 'Git and GitHub for Beginners - Crash Course',
      author: 'freeCodeCamp',
      lang: 'Angles',
      duration: '1h 8min',
      embedId: 'RGOj5yH7evk',
      desc: 'Tutorial classic de freeCodeCamp en angles. Molt clar i amb exemples practics.',
      level: 'Principiant',
    },
    {
      title: 'Git MERGE vs REBASE',
      author: 'The Modern Coder',
      lang: 'Angles',
      duration: '6min',
      embedId: 'CRlGDDprdOQ',
      desc: 'Explicacio visual molt clara de la diferencia entre merge i rebase.',
      level: 'Intermedi',
    },
  ];

  const resources = [
    {
      title: 'Git - Documentacio oficial',
      url: 'https://git-scm.com/doc',
      type: 'Documentacio',
    },
    {
      title: 'GitHub Docs',
      url: 'https://docs.github.com/es',
      type: 'Documentacio',
    },
    {
      title: 'GitLab Docs',
      url: 'https://docs.gitlab.com/',
      type: 'Documentacio',
    },
    {
      title: 'Learn Git Branching (interactiu)',
      url: 'https://learngitbranching.js.org/?locale=es_AR',
      type: 'Interactiu',
    },
    {
      title: 'Oh My Git! (videojoc)',
      url: 'https://ohmygit.org/',
      type: 'Interactiu',
    },
    {
      title: 'Git Cheat Sheet (PDF)',
      url: 'https://education.github.com/git-cheat-sheet-education.pdf',
      type: 'Referencia',
    },
  ];

  return (
    <section id="videos" className="videos">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Recursos</span>
          <h2 className="section-title">Video tutorials i <span className="gold">recursos</span></h2>
          <p className="section-desc">
            Videos recomanats per aprofundir i recursos interactius per practicar.
          </p>
        </div>

        <div className="videos-grid">
          {videos.map((video, i) => (
            <div className="video-card" key={i}>
              <div className="video-embed">
                <iframe
                  src={`https://www.youtube.com/embed/${video.embedId}`}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="video-info">
                <div className="video-meta">
                  <span className={`video-level ${video.level.toLowerCase()}`}>{video.level}</span>
                  <span className="video-lang">{video.lang}</span>
                  <span className="video-duration">{video.duration}</span>
                </div>
                <h3>{video.title}</h3>
                <p className="video-author">{video.author}</p>
                <p className="video-desc">{video.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="resources-section">
          <h3>Recursos addicionals</h3>
          <div className="resources-grid">
            {resources.map((r, i) => (
              <a href={r.url} target="_blank" rel="noopener noreferrer" className="resource-card" key={i}>
                <span className="resource-type">{r.type}</span>
                <h4>{r.title}</h4>
                <span className="resource-url">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                  Obrir
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Videos;
